// import ifEmoji from 'if-emoji';
import s from './style.css';

const Emoji = ({ children }) => <span className={s.emoji}>{children}</span>;

export default Emoji;



// WEBPACK FOOTER //
// ./components/Emoji/index.js